import {
  QueryClient,
  QueryClientProvider,
  QueryObserver,
  useInfiniteQuery,
  useMutation,
  useQueries,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

export { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const httpQueryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false },
  },
});

export {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useInfiniteQuery,
  useQueries,
  useQueryClient,
  useMutation,
  QueryObserver,
};
